import { useCallback } from 'react';
import { useQueryClient} from '@common-fe/common-fe';

import useFilesInDocumentStore from '@/components/controls/DropScan/useFilesInDocument.store';
import { API_URL } from '@/dtos';
import { USE_MY_MONEY_UPLOAD_STORE_KEY } from '@/modules/UseMyMoney/UseMyMoney.types';

const useInvalidateOcrQuery = () => {
  const queryClient = useQueryClient();
  const { values: documentValues } = useFilesInDocumentStore(USE_MY_MONEY_UPLOAD_STORE_KEY);

  const invalidateOcrQuery = useCallback(async () => {
    if (documentValues?.documentId) {
      await queryClient.invalidateQueries({
        queryKey: [API_URL.DOCUMENTS_OCR_OPTIONS_BY_DOCUMENT_ID(documentValues?.documentId as string)],
      });
      return;
    }

    await queryClient.invalidateQueries({
      queryKey: [API_URL.DOCUMENTS_OCR_OPTIONS],
    });
  }, [queryClient, documentValues?.documentId]);

  return {
    invalidateOcrQuery,
  };
};

export default useInvalidateOcrQuery;
